enum SponsorType {
  Platin,
  Gold,
  Silver,
  Bronze,
  Other
}

export default SponsorType;